import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=9e88bace&scoped=true&"
import script from "./PostDetail.vue?vue&type=script&lang=js&"
export * from "./PostDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=9e88bace&lang=scss&scoped=true&"
import style1 from "./PostDetail.vue?vue&type=style&index=1&id=9e88bace&scoped=true&lang=css&"
import style2 from "./PostDetail.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e88bace",
  null
  
)

export default component.exports